import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BulkApplicantMessage, ApplicantIndividualTestMessage } from '../interfaces/bulk-applicant-message';
import { ApplicantTrackerResources } from '../applicant-tracker.resource';

@Injectable()
export class ApplicantMessageService {
    constructor(private http: HttpClient) {}

    async onBulkSendApplicantMessage(bulkApplicantMessage: BulkApplicantMessage): Promise<void> {
        const payload = {
            data: {
                attributes: bulkApplicantMessage,
            },
        };

        const url = ApplicantTrackerResources.BulkApplicantMessage;

        await this.http.post(url, payload).toPromise();
    }

    async onApplicantIndividualTestMessage(bulkApplicantTestMessage: ApplicantIndividualTestMessage): Promise<void> {
        const payload = { data: { attributes: bulkApplicantTestMessage } };

        const url = ApplicantTrackerResources.ApplicantIndividualTestMessage;

        await this.http.post(url, payload).toPromise();
    }
}
